import { emailTemplateSchema } from "@redotech/redo-merchant-marketing-rpc/schema/email-templates";
import type { InferRpcDefinition } from "@redotech/rpc/definition";

export const rpcDefinition = { ...emailTemplateSchema };

export type RedoMerchantEmailTemplatesRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
